export default {
  init() {
    // JavaScript to be fired on the self assessment page
  },
  finalize() {
    setTimeout(function() {
      $('.intro-slide-title').animate({
        opacity: 1,
      }, 1000, function() {
        // Animation complete.
        setTimeout(function() {
          $('.intro-slide-text p').each(function(i) {
            var $p = $(this);
            setTimeout(function() {
              $p.animate({
              opacity: 1,
            }, 1000, function() {
              // Animation complete.
              if(i == 2) {
                $('.intro-button').addClass('active');
              }
            });
          }, i*5500);
          });
        }, 1300);
      });
    }, 500);

    var selfassessmentcarousel = $('.self-assessment-carousel');

    selfassessmentcarousel.on('init reInit afterChange', function(event, slick, currentSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based) (there was +1)
      var i = (currentSlide ? currentSlide : 0) + 1;
    //  $status.text(i + '/' + slick.slideCount);

      //console.log(i);
      calcPercentage(slick.slideCount, i)

      if(currentSlide > 0 && (currentSlide + 1 < slick.slideCount)) {
        if(! $('.skill-domain-title, .skill-domain-modal').hasClass('active')) {
          $('.skill-domain-title, .skill-domain-modal').addClass('active');
          $('.progress-bar').addClass('active');
        }

        if(currentSlide > 1) {
          $('.prev-slide').addClass('active');
        } else {
          $('.prev-slide').removeClass('active');
        }

        if($('.slide[data-slick-index="' + currentSlide + '"]').hasClass('answered')) {
          $('.next-slide').addClass('active');
        } else {
          $('.next-slide').removeClass('active');
        }

        var domainclass = $('.slide[data-slick-index="' + currentSlide + '"]').attr('data-skilldomain');
        var domainclasslabel = $('.slide[data-slick-index="' + currentSlide + '"]').attr('data-skilldomainlabel');

        if(! $('.skill-domain-title').hasClass(domainclass)) {
          $('.skill-domain-title').attr('class', 'skill-domain-title active');
          $('.skill-domain-modal').attr('class', 'modal-content skill-domain-modal');
          $('.skill-domain-title, .skill-domain-modal').addClass(domainclass);
          $('.skill-domain-title span').html(domainclasslabel);
        }

      } else {
        $('.skill-domain-title').removeClass('active');
        $('.progress-bar').removeClass('active');
        $('.next-slide').removeClass('active');
        $('.prev-slide').removeClass('active');
      }
    });

    selfassessmentcarousel.slick({
      dots: false,
      infinite: false,
      speed: 1000,
      slidesToShow: 1,
      autoplay: false,
      draggable: false,
      arrows: false,
      swipe: false,
      controls: false,
      slidesToScroll: 1,
      //initialSlide: 48,
    });

    selfassessmentcarousel.on('beforeChange', function(event, slick, currentSlide) {
      $('.slick-slide[data-slick-index=' + currentSlide + ']').removeClass('animdone');
    });

    selfassessmentcarousel.on('afterChange', function() {
      $('.slick-slide.slick-active').addClass('animdone');
    });

    const ajax_url = window.sage.ajax_url || false;

    $('.answer-button').one('click', function() {
      if(! $(this).hasClass('disabled')) {
        var parentslide = $(this).closest('.slide');
        parentslide.addClass('answered');
        var questionheading = parentslide.find('.question');

        parentslide.find('.answer-button').addClass('disabled');
        $(this).addClass('selected');

        var userid = parentslide.attr('data-userid');
        var skilldomain = parentslide.attr('data-skilldomain');
        var questionid = parentslide.attr('data-questionid');
        var useranswer = $(this).attr('data-answervalue');
        var question = questionheading.html();
        var domainlabel = parentslide.attr('data-skilldomainlabel');

        var data = {
          action : 'ajax_change_points',
          user_id : userid,
          domain_label : domainlabel,
          domain : skilldomain,
          question : question,
          question_id : questionid,
          user_answer : useranswer,
        };

        $.ajax({
          url: ajax_url,
          type : 'post',
          data : data,
          success : function() {
            selfassessmentcarousel.slick('slickNext');
          },
        });
      }
    });

    $('.intro-button').one('click', function() {

        var parentslide = $(this).closest('.slide');
        var userid = parentslide.attr('data-userid');

        var data = {
          action : 'ajax_start_assessment',
          user_id : userid,
        };

        $.ajax({
          url: ajax_url,
          type : 'post',
          data : data,
          success : function() {
            selfassessmentcarousel.slick('slickNext');
          },
        });

    });


    $('.outro-button').one('click', function() {
        var parentslide = $(this).closest('.slide');
        var userid = parentslide.attr('data-userid');
        var targeturl = $(this).attr('data-target');

        var data = {
          action : 'ajax_finish_assessment',
          user_id : userid,
        };

        $.ajax({
          url: ajax_url,
          type : 'post',
          data : data,
          success : function() {
            window.location.href = targeturl;
          },
        });

    });

    $('.prev-slide').click(function() {
      selfassessmentcarousel.slick('slickPrev');
    });

    $('.next-slide').click(function() {
      selfassessmentcarousel.slick('slickNext');
    });

    function calcPercentage(total, current) {
      var percentage = (current / total) * 100  + '%';
      $('.progress-bar .bar').css('width', percentage);
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/selfAssessment.js